// NOTE(@hassankhan): This is required because Metro can't parse platform-suffixes
// from subpath export declarations in `package.json`
export * from './dom/dom';

//# sourceMappingURL=dom.js.map
